import React__default from 'react';
import Typography from '../../Typography/index.js';
import { Name, Description } from './NameAndDescription.styles.js';

var NameAndDescription = function NameAndDescription(_ref) {
  var _ref$name = _ref.name,
    name = _ref$name === void 0 ? null : _ref$name,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? null : _ref$description;
  return /*#__PURE__*/React__default.createElement("div", null, name && /*#__PURE__*/React__default.createElement(Name, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h5",
    className: "title ".concat(description && 'collapse-bottom-spacing'),
    dangerouslySetInnerHTML: {
      __html: "".concat(name).trim()
    }
  })), description && /*#__PURE__*/React__default.createElement(Description, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "",
    className: "description",
    dangerouslySetInnerHTML: {
      __html: "".concat(description).trim()
    }
  })));
};

/* eslint-enable react/no-danger */
var NameAndDescription$1 = NameAndDescription;

export { NameAndDescription$1 as default };
//# sourceMappingURL=NameAndDescription.js.map
